import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-content-and-learing-excel-upload',
  templateUrl: './content-and-learing-excel-upload.component.html',
  styleUrls: ['./content-and-learing-excel-upload.component.scss']
})
export class ContentAndLearingExcelUploadComponent implements OnInit {

  uploadHidden = false;
  excel_data: any;
  localData:any;
  approvedReject: any = [];
  apiData: any;
  tableData = {
    headers: [],
    rows: [],
    keys: []
  }
  isExcelUpload: boolean = false;
  modal: any;
  taskId: any = "";
  engagementType: any = "";

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiconfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private router: Router,
  ) {
    this.taskId = this.activatedRoute.snapshot.paramMap.get("task_id")
    this.engagementType = this.activatedRoute.snapshot.paramMap.get("engagement_type")
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
  }

  ngOnInit() {
  }

  openUploadmodel(modal) {
    this.modalService.open(modal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  uploadXlsx(eve, modal) {
    this.modal = modal
    // debugger
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      this.excelUpload(res.data)

    })
  }

  excelUpload(res) {
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];
    console.log(res)

    let payload = {
      engagement_type: this.engagementType,
      task_id: this.taskId,
      mobile_numbers: res,
      whitelist_type : this.localData.whitelist_type,
    }
    console.log(payload)
    this.apiService.post(this.apiconfig.whiteListEngagementUser, payload).subscribe((res: any) => {
      if (res.body.data.errors.length != 0){
        this.toast.Success('File Uploaded Successfully')
        console.log(res.body.data)
        this.uploadHidden = true
        this.tableData.headers = ["Mobile Number", "Reason"]
        this.apiData = res.body.data;
        if (res.body.data.errors.length == 0) {
          this.isExcelUpload = true;
        }
        this.tableData.rows = res.body.data.errors;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
      }else{
        this.toast.Success('File Uploaded Successfully')
        this.router.navigate(["/hubAdmin/content-and-learnings"])
      }

    })
  }

  downloadExcel() {
    let header = ["Mobile Number"]
    let filename = "contemnt_learning_templete"
    this.exportExcelService.commonPrintHeadersTwo(header, filename, 'users')
  }

  RejectedOutletExcel() {
    this.xlsx.export(this.tableData.rows, "rejected_list")
  }
  ngOnDestroy() {

  }
}
